import _slicedToArray from "/codebuild/output/src4175957240/src/bluewaveenergy-web-gatsby-react/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import ownerDocument from 'dom-helpers/ownerDocument';
import canUseDOM from 'dom-helpers/canUseDOM';
import { useState, useEffect } from 'react';
import useWindow from './useWindow';
export var resolveContainerRef = function resolveContainerRef(ref, document) {
  if (!canUseDOM) return null;
  if (ref == null) return (document || ownerDocument()).body;
  if (typeof ref === 'function') ref = ref();
  if (ref && 'current' in ref) ref = ref.current;
  if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
  return null;
};
export default function useWaitForDOMRef(ref, onResolved) {
  var window = useWindow();
  var _useState = useState(function () {
      return resolveContainerRef(ref, window == null ? void 0 : window.document);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    resolvedRef = _useState2[0],
    setRef = _useState2[1];
  if (!resolvedRef) {
    var earlyRef = resolveContainerRef(ref);
    if (earlyRef) setRef(earlyRef);
  }
  useEffect(function () {
    if (onResolved && resolvedRef) {
      onResolved(resolvedRef);
    }
  }, [onResolved, resolvedRef]);
  useEffect(function () {
    var nextRef = resolveContainerRef(ref);
    if (nextRef !== resolvedRef) {
      setRef(nextRef);
    }
  }, [ref, resolvedRef]);
  return resolvedRef;
}